<template>
  <div v-if="dataWasDownloadedSuccessfully">
    <ul class="list-none d-grid">
      <li class="cell" v-for="(benefit, index) in benefits" :key="index">
        <img :src="benefit.fields.icon.fields.file.url" class="mb-2" alt="">
        <small class="font-xs">
          <h5 class="mb-2">{{ benefit.fields.title }}</h5>
          <span class="d-block">
            {{ benefit.fields.description }}
          </span>
        </small>
      </li>
    </ul>
  </div>
</template>
<script>
  import { getContent } from '@/javascripts/contentful';

  export default {
    name: 'benefitsApp',
    props: ['entryId'],
    data() {
      return {
        dataWasDownloadedSuccessfully: false,
        benefits: null,
      }
    },
    async mounted() {
      const { fields } = await getContent(this.entryId)
      if (fields) {
        this.benefits = { ...fields.benefitList }
        this.dataWasDownloadedSuccessfully = true
      }
    },
  }
</script>
